export default "__VITE_ASSET___E7lu4cu__"